/* ============================================================
   AP10 Product Personalization
   - Live-Vorschau auf Canvas (WYSIWYG)
   - PDF-Erzeugung im Browser (Mini-PDF-Builder, JPEG-Embed)
   - Upload in Supabase Storage
   - Add-to-Cart mit Line-Item-Properties + 5€-Aufschlagsprodukt
   ============================================================ */
(function () {
  if (customElements.get('product-personalization')) return;

  /* ----------------------------------------------------------
     LAYOUT-KONFIGURATION (relativ zur Größe des Hintergrundbilds)
     Werte aus dem Overlay-Design abgeleitet — hier fein-tunen.
     ---------------------------------------------------------- */
  const LAYOUT = {
    blockX: 0.2205,      // linke Kante von Text 1 / Name / Text 2 (rel. Breite)
    nameY: 0.8978,       // vertikale MITTE der Namenszeile (rel. Höhe)
    nameSize: 0.064,     // maximale Schriftgröße Name (rel. Breite) — schrumpft bei langen Namen
    smallSize: 0.019,    // Schriftgröße Text 1 / Text 2 (rel. Breite)
    smallGapH: 0.033,    // Abstand Mitte Name ↔ Mitte Text 1/2 (rel. Höhe)
    numberSize: 0.082,   // Schriftgröße Startnummer (rel. Breite)
    edgeMargin: 0.055,   // Rand-Abstand: Nummer → linker Rand == Flagge → rechter Rand (rel. Breite)
    flagGap: 0.030,      // Abstand Name-Ende ↔ Flagge (rel. Breite)
    flagWidth: 0.046,    // Breite der Flagge (rel. Breite)
    nameColor: '#FFFFFF',
    smallColor: 'rgba(255,255,255,0.75)',
    /* Startnummer: Füllung + doppelte Outline
       (Füllfarbe → schwarze Kontur → außen nochmal Füllfarbe) */
    numberColor: '#F86E15',        // Füllfarbe + äußere Outline (Fallback)
    numberOutline: '#000000',      // schwarze Kontur dazwischen
    numberOutlineWidth: 0.10,      // Breite schwarze Kontur (rel. Nummerngröße)
    numberOuterWidth: 0.22         // Gesamtbreite äußere Outline (rel. Nummerngröße)
  };

  /* Zoom-Ausschnitt: vertikales Band des Posters, das die Lightbox zeigt
     (relativ zur Bildhöhe) — fokussiert auf den Personalisierungs-Bereich. */
  const ZOOM_REGION = { y0: 0.76, y1: 1.0 };

  /* Poster-Schriften (Google Fonts, im Snippet verlinkt):
     - Name + Text 1/2: Poppins (Name: erstes Wort 400, Rest 700)
     - Startnummer: Rubik, kursiv 900 */
  const TEXT_FONT = '"Poppins", sans-serif';
  const NUMBER_BASE_FONT = '"Rubik", sans-serif';

  /* Optional: Eigener Racing-Font für die Startnummer.
     Fontdatei in assets/ legen und hier die URL eintragen — wird dann
     der Rubik vorangestellt. */
  const NUMBER_FONT_URL = '';
  const NUMBER_FONT_FAMILY = 'PersoNumberFont';

  const PDF_DPI = 300; // BG-Pixel → physische PDF-Größe (px / DPI = Zoll)

  /* Vollständige ISO-3166-1-alpha-2 Länderliste (Namen via Intl.DisplayNames) */
  const COUNTRY_CODES = ('ad ae af ag ai al am ao ar as at au aw ax az ba bb bd be bf bg bh bi bj bl bm bn bo bq br bs bt bw by bz ca cc cd cf cg ch ci ck cl cm cn co cr cu cv cw cx cy cz de dj dk dm do dz ec ee eg eh er es et fi fj fk fm fo fr ga gb gd ge gf gg gh gi gl gm gn gp gq gr gs gt gu gw gy hk hn hr ht hu id ie il im in io iq ir is it je jm jo jp ke kg kh ki km kn kp kr kw ky kz la lb lc li lk lr ls lt lu lv ly ma mc md me mf mg mh mk ml mm mn mo mp mq mr ms mt mu mv mw mx my mz na nc ne nf ng ni nl no np nr nu nz om pa pe pf pg ph pk pl pm pn pr ps pt pw py qa re ro rs ru rw sa sb sc sd se sg sh si sj sk sl sm sn so sr ss st sv sx sy sz tc td tg th tj tk tl tm tn to tr tt tv tw tz ua ug us uy uz va vc ve vg vi vn vu wf ws ye yt za zm zw').split(' ');

  /* ---------------- Mini-PDF-Builder ----------------
     Erzeugt ein einseitiges PDF mit eingebettetem JPEG (DCTDecode).
     Seitengröße = Bildgröße in pt (px * 72 / PDF_DPI). */
  function buildPdf(jpegBytes, wPx, hPx, dpi) {
    const wPt = (wPx * 72 / dpi).toFixed(2);
    const hPt = (hPx * 72 / dpi).toFixed(2);
    const te = (s) => {
      const b = new Uint8Array(s.length);
      for (let i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 0xff;
      return b;
    };
    const content = `q ${wPt} 0 0 ${hPt} 0 0 cm /Im1 Do Q`;
    const objs = [
      '1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n',
      '2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n',
      `3 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${wPt} ${hPt}] /Resources << /XObject << /Im1 4 0 R >> >> /Contents 5 0 R >>\nendobj\n`,
      null, // Bild-Objekt (binär, unten)
      `5 0 obj\n<< /Length ${content.length} >>\nstream\n${content}\nendstream\nendobj\n`
    ];
    const imgHead = `4 0 obj\n<< /Type /XObject /Subtype /Image /Width ${wPx} /Height ${hPx} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpegBytes.length} >>\nstream\n`;
    const imgTail = '\nendstream\nendobj\n';

    const parts = [];
    const offsets = [0]; // Index 0 = frei
    let pos = 0;
    const push = (bytes) => { parts.push(bytes); pos += bytes.length; };

    push(te('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n'));
    for (let i = 0; i < objs.length; i++) {
      offsets.push(pos);
      if (i === 3) {
        push(te(imgHead));
        push(jpegBytes);
        push(te(imgTail));
      } else {
        push(te(objs[i]));
      }
    }
    const xrefPos = pos;
    let xref = 'xref\n0 6\n0000000000 65535 f \n';
    for (let i = 1; i <= 5; i++) xref += String(offsets[i]).padStart(10, '0') + ' 00000 n \n';
    xref += `trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xrefPos}\n%%EOF\n`;
    push(te(xref));

    const total = parts.reduce((n, p) => n + p.length, 0);
    const out = new Uint8Array(total);
    let o = 0;
    for (const p of parts) { out.set(p, o); o += p.length; }
    return new Blob([out], { type: 'application/pdf' });
  }

  /* ---------------- Hilfen ---------------- */
  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('Bild konnte nicht geladen werden: ' + src));
      img.src = src;
    });
  }

  function roundRectPath(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function flagEmoji(code) {
    return code.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
  }

  class ProductPersonalization extends HTMLElement {
    connectedCallback() {
      try {
        this.cfg = JSON.parse(this.querySelector('[data-perso-config]').textContent);
      } catch (e) {
        console.error('[Perso] Config fehlerhaft', e);
        return;
      }
      this.trigger = this.querySelector('.perso-trigger');
      this.modal = this.querySelector('.perso-modal');

      // Modal an <body> verschieben — sonst fangen Transform/Overflow-Eltern
      // der Produktseite den z-index ab und die Galerie überlagert das Modal.
      if (this.modal.parentNode !== document.body) {
        document.body.appendChild(this.modal);
      }

      this.previewCanvas = this.modal.querySelector('.perso-preview__canvas');
      this.form = this.modal.querySelector('.perso-form');
      this.errorEl = this.modal.querySelector('.perso-error');
      this.submitBtn = this.modal.querySelector('.perso-submit');
      this.flagCache = {};
      this.bgCache = {};
      this.fontFamily = this.resolveFontFamily();
      this.renderQueued = false;

      this.buildCountrySelect();
      this.bindEvents();
      this.syncVariant();

      if (NUMBER_FONT_URL) {
        const f = new FontFace(NUMBER_FONT_FAMILY, `url(${NUMBER_FONT_URL})`);
        f.load().then((ff) => document.fonts.add(ff)).catch(() => {});
      }
    }

    resolveFontFamily() {
      const probe = document.querySelector('.product__title, h1');
      return (probe ? getComputedStyle(probe).fontFamily : 'sans-serif');
    }

    /* Stellt sicher, dass die Poster-Fonts geladen sind, bevor gezeichnet wird */
    ensureFonts() {
      if (!this._fontsPromise) {
        this._fontsPromise = Promise.all([
          document.fonts.load('400 100px Poppins'),
          document.fonts.load('700 100px Poppins'),
          document.fonts.load('italic 900 100px Rubik'),
          document.fonts.ready
        ]).catch(() => {});
      }
      return this._fontsPromise;
    }

    /* ---------- Varianten-Sync (Trigger nur zeigen, wenn BG existiert) ---------- */
    currentVariantId() {
      const input = document.querySelector('form[id^="product-form"] input[name="id"], form[action*="/cart/add"] input[name="id"]');
      return input ? String(input.value) : null;
    }

    currentBgUrl() {
      const vid = this.currentVariantId();
      return (vid && this.cfg.variants && this.cfg.variants[vid]) || null;
    }

    syncVariant() {
      const has = !!this.currentBgUrl();
      this.trigger.hidden = !has;
      if (!has && this.modal.classList.contains('is-open')) this.closeModal();
    }

    /* ---------- Länder-Dropdown (Flagge + Kürzel, kompakt) ---------- */
    buildCountrySelect() {
      const sel = this.form.querySelector('[name="land"]');
      let dn = null;
      try { dn = new Intl.DisplayNames(['de'], { type: 'region' }); } catch (e) {}
      const entries = COUNTRY_CODES.slice().sort();
      for (const c of entries) {
        const opt = document.createElement('option');
        opt.value = c;
        opt.textContent = flagEmoji(c) + ' ' + c.toUpperCase();
        if (dn) opt.title = dn.of(c.toUpperCase()) || c.toUpperCase();
        if (c === 'de') opt.selected = true;
        sel.appendChild(opt);
      }
    }

    /* ---------- Events ---------- */
    bindEvents() {
      this.trigger.addEventListener('click', (e) => { e.preventDefault(); this.openModal(); });
      // WICHTIG: im Modal suchen — das Modal wurde an <body> verschoben!
      this.modal.querySelectorAll('[data-perso-close]').forEach((el) =>
        el.addEventListener('click', (e) => { e.preventDefault(); this.closeModal(); })
      );
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.zoomEl && !this.zoomEl.hidden) { this.closeZoom(); return; }
        if (this.modal.classList.contains('is-open')) this.closeModal();
      });
      this.form.addEventListener('input', () => this.queuePreview());
      this.form.addEventListener('change', () => this.queuePreview());
      this.submitBtn.addEventListener('click', (e) => { e.preventDefault(); this.addToCart(); });

      // Zoom-Lightbox
      this.zoomEl = this.modal.querySelector('.perso-zoom');
      this.zoomCanvas = this.modal.querySelector('.perso-zoom__canvas');
      const zoomBtn = this.modal.querySelector('.perso-preview__zoom');
      if (zoomBtn) zoomBtn.addEventListener('click', (e) => { e.preventDefault(); this.openZoom(); });
      if (this.zoomEl) {
        this.zoomEl.addEventListener('click', (e) => {
          if (e.target === this.zoomEl || e.target.closest('[data-perso-zoom-close]')) this.closeZoom();
        });
      }

      // Variantenwechsel beobachten
      document.addEventListener('change', (e) => {
        if (e.target && e.target.name && e.target.name.indexOf('options[') === 0) {
          setTimeout(() => this.syncVariant(), 50);
          setTimeout(() => this.syncVariant(), 400);
        }
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.syncVariant(), 0));
      }
    }

    openModal() {
      if (!this.currentBgUrl()) return;
      this.modal.classList.add('is-open');
      document.body.classList.add('perso-modal-open');
      this.showError('');
      this._previewBox = null; // Vorschau-Fläche bei jedem Öffnen neu messen
      this.queuePreview();
    }

    /* Verfügbare Vorschau-Fläche EINMAL messen (Content-Box ohne Padding).
       Wichtig: nicht bei jedem Render neu messen — sonst wächst der
       Container mit dem Canvas mit (Feedback-Schleife). */
    measurePreviewBox() {
      const holder = this.previewCanvas.parentElement;
      const cs = getComputedStyle(holder);
      const w = holder.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      const h = holder.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      return { w: Math.max(50, w || 420), h: Math.max(50, h || 560) };
    }

    closeModal() {
      this.closeZoom();
      this.modal.classList.remove('is-open');
      document.body.classList.remove('perso-modal-open');
    }

    /* ---------- Formularwerte ---------- */
    values() {
      const g = (n) => (this.form.querySelector('[name="' + n + '"]') || { value: '' }).value.trim();
      const checkedColor = this.form.querySelector('[name="numcolor"]:checked');
      return {
        nummer: g('nummer').replace(/[^0-9]/g, '').slice(0, 2),
        name: g('name'),
        text1: g('text1'),
        text2: g('text2'),
        land: g('land') || 'de',
        numcolor: (checkedColor && checkedColor.value) || ''
      };
    }

    /* Vorschau-Werte: leere Felder werden mit Platzhaltern (data-preview)
       gefüllt, damit das Poster von Anfang an "fertig" aussieht. Die
       Eingabefelder selbst bleiben leer. */
    previewValues() {
      const v = this.values();
      const ph = (n) => {
        const el = this.form.querySelector('[name="' + n + '"]');
        return (el && el.dataset.preview) || '';
      };
      return {
        nummer: v.nummer || ph('nummer'),
        name: v.name || ph('name'),
        text1: v.text1 || ph('text1'),
        text2: v.text2 || ph('text2'),
        land: v.land,
        numcolor: v.numcolor
      };
    }

    /* ---------- Assets laden ---------- */
    async getBg() {
      const url = this.currentBgUrl();
      if (!url) throw new Error('Kein Hintergrundbild für diese Variante hinterlegt.');
      if (!this.bgCache[url]) this.bgCache[url] = loadImage(url);
      return this.bgCache[url];
    }

    async getFlag(code) {
      if (!this.flagCache[code]) {
        this.flagCache[code] = loadImage('https://flagcdn.com/w160/' + code + '.png').catch(() => null);
      }
      return this.flagCache[code];
    }

    /* ---------- Zeichnen (gemeinsam für Vorschau + Final) ---------- */
    async drawScene(ctx, W, H, v, bg, flag) {
      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(bg, 0, 0, W, H);

      const name = (v.name || '').trim().toUpperCase();
      const blockX = LAYOUT.blockX * W;
      const nameY = LAYOUT.nameY * H;
      const nameSize = LAYOUT.nameSize * W;
      const smallSize = LAYOUT.smallSize * W;
      const smallGap = LAYOUT.smallGapH * H;

      ctx.textBaseline = 'middle';

      /* Pixelgenaue Linksbündigkeit: unterschiedliche Schriftgrößen haben
         unterschiedliche Glyphen-Seitenränder — wir kompensieren über
         actualBoundingBoxLeft, damit die Tinte aller Zeilen exakt bei
         blockX beginnt. */
      const inkAlignedX = (text) => {
        const m = ctx.measureText(text);
        const abbl = (typeof m.actualBoundingBoxLeft === 'number') ? m.actualBoundingBoxLeft : 0;
        return blockX + abbl;
      };

      // Text 1 (klein, über dem Namen) — Poppins 400
      if (v.text1) {
        ctx.textAlign = 'left';
        ctx.font = '400 ' + smallSize + 'px ' + TEXT_FONT;
        ctx.fillStyle = LAYOUT.smallColor;
        ctx.fillText(v.text1, inkAlignedX(v.text1), nameY - smallGap);
      }

      // Name (groß, Großbuchstaben) — Poppins: erstes Wort 400, Rest 700.
      // Maximale Breite: Name + Flagge dürfen den rechten Rand-Abstand
      // (edgeMargin) nicht überschreiten — sonst schrumpft die Schrift.
      let nameW = 0;
      let nameInkCenterY = nameY; // sichtbare (optische) Mitte der Namenszeile
      if (name) {
        ctx.textAlign = 'left';
        ctx.fillStyle = LAYOUT.nameColor;
        const words = name.split(/\s+/).filter(Boolean);
        const firstWord = words.length > 1 ? words[0] : '';
        const boldPart = words.length > 1 ? words.slice(1).join(' ') : (words[0] || '');

        const measureAt = (size) => {
          let w = 0;
          if (firstWord) {
            ctx.font = '400 ' + size + 'px ' + TEXT_FONT;
            w += ctx.measureText(firstWord).width + ctx.measureText(' ').width;
          }
          ctx.font = '700 ' + size + 'px ' + TEXT_FONT;
          w += ctx.measureText(boldPart).width;
          return w;
        };

        const maxNameW = (1 - LAYOUT.edgeMargin) * W - LAYOUT.flagWidth * W - LAYOUT.flagGap * W - blockX;
        let fittedSize = nameSize;
        const fullNameW = measureAt(nameSize);
        if (fullNameW > maxNameW) fittedSize = nameSize * (maxNameW / fullNameW);

        const regFont = '400 ' + fittedSize + 'px ' + TEXT_FONT;
        const boldFont = '700 ' + fittedSize + 'px ' + TEXT_FONT;

        if (firstWord) {
          ctx.font = regFont;
          const x = inkAlignedX(firstWord);
          ctx.fillText(firstWord, x, nameY);
          const wFirst = ctx.measureText(firstWord).width;
          const wSpace = ctx.measureText(' ').width;
          ctx.font = boldFont;
          const xBold = x + wFirst + wSpace;
          ctx.fillText(boldPart, xBold, nameY);
          nameW = (xBold + ctx.measureText(boldPart).width) - x;
        } else {
          ctx.font = boldFont;
          const x = inkAlignedX(boldPart);
          ctx.fillText(boldPart, x, nameY);
          nameW = ctx.measureText(boldPart).width;
        }

        // Optische Mitte der Großbuchstaben bestimmen (Ink-Bounds):
        // Bei textBaseline "middle" liegt die sichtbare Caps-Mitte über nameY.
        const mm = ctx.measureText(boldPart || firstWord);
        if (typeof mm.actualBoundingBoxAscent === 'number' && typeof mm.actualBoundingBoxDescent === 'number') {
          nameInkCenterY = nameY + (mm.actualBoundingBoxDescent - mm.actualBoundingBoxAscent) / 2;
        }
      }

      // Text 2 (klein, unter dem Namen) — Poppins 400
      if (v.text2) {
        ctx.textAlign = 'left';
        ctx.font = '400 ' + smallSize + 'px ' + TEXT_FONT;
        ctx.fillStyle = LAYOUT.smallColor;
        ctx.fillText(v.text2, inkAlignedX(v.text2), nameY + smallGap);
      }

      // Startnummer — Rubik kursiv 900, LINKS am Rand verankert:
      // Abstand Nummer → linker Rand == Abstand Flagge → rechter Rand (edgeMargin).
      // Die halbe äußere Outline wird kompensiert, damit die sichtbare Kante passt.
      if (v.nummer) {
        const numSize = LAYOUT.numberSize * W;
        const numX = LAYOUT.edgeMargin * W + (numSize * LAYOUT.numberOuterWidth) / 2;
        const numFamily = (NUMBER_FONT_URL ? NUMBER_FONT_FAMILY + ', ' : '') + NUMBER_BASE_FONT;
        ctx.textAlign = 'left';
        ctx.font = 'italic 900 ' + numSize + 'px ' + numFamily;
        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;
        const numColor = v.numcolor || LAYOUT.numberColor;
        // 1) Äußere Outline — gleiche Farbe wie die Füllung (breitester Stroke)
        ctx.strokeStyle = numColor;
        ctx.lineWidth = numSize * LAYOUT.numberOuterWidth;
        ctx.strokeText(v.nummer, numX, nameY);
        // 2) Schwarze Kontur dazwischen
        ctx.strokeStyle = LAYOUT.numberOutline;
        ctx.lineWidth = numSize * LAYOUT.numberOutlineWidth;
        ctx.strokeText(v.nummer, numX, nameY);
        // 3) Füllung
        ctx.fillStyle = numColor;
        ctx.fillText(v.nummer, numX, nameY);
      }

      // Flagge (rechts neben dem Namen, vertikal zentriert, abgerundet)
      if (flag && name) {
        const fw = LAYOUT.flagWidth * W;
        const fh = fw * (2 / 3);
        const fx = blockX + nameW + LAYOUT.flagGap * W;
        const fy = nameInkCenterY - fh / 2; // vertikal auf optischer Text-Mitte
        ctx.save();
        roundRectPath(ctx, fx, fy, fw, fh, fh * 0.16);
        ctx.clip();
        ctx.drawImage(flag, fx, fy, fw, fh);
        ctx.restore();
      }
    }

    /* ---------- Live-Vorschau ---------- */
    queuePreview() {
      if (this.renderQueued) return;
      this.renderQueued = true;
      setTimeout(() => { this.renderQueued = false; this.renderPreview(); }, 80);
    }

    async renderPreview() {
      try {
        const v = this.previewValues();
        const [bg, flag] = await Promise.all([this.getBg(), this.getFlag(v.land), this.ensureFonts()]);
        if (!this._previewBox) this._previewBox = this.measurePreviewBox();
        const maxW = this._previewBox.w;
        const maxH = this._previewBox.h;
        const scale = Math.min(maxW / bg.naturalWidth, maxH / bg.naturalHeight);
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const W = Math.round(bg.naturalWidth * scale * dpr);
        const H = Math.round(bg.naturalHeight * scale * dpr);
        this.previewCanvas.width = W;
        this.previewCanvas.height = H;
        this.previewCanvas.style.width = Math.round(W / dpr) + 'px';
        this.previewCanvas.style.height = Math.round(H / dpr) + 'px';
        await this.drawScene(this.previewCanvas.getContext('2d'), W, H, v, bg, flag);
      } catch (err) {
        console.error('[Perso] Vorschau-Fehler:', err);
        this.showError(err.message || 'Vorschau konnte nicht geladen werden.');
      }
    }

    /* ---------- Zoom-Lightbox (fokussiert den Personalisierungs-Bereich) ---------- */
    async openZoom() {
      if (!this.zoomEl) return;
      this.zoomEl.hidden = false;
      try {
        const v = this.previewValues();
        const [bg, flag] = await Promise.all([this.getBg(), this.getFlag(v.land), this.ensureFonts()]);
        const maxW = window.innerWidth * 0.94;
        const maxH = window.innerHeight * 0.86;

        // Nur das untere Band (Personalisierung) formatfüllend anzeigen
        const bandFrac = ZOOM_REGION.y1 - ZOOM_REGION.y0;
        const bandW = bg.naturalWidth;
        const bandH = bg.naturalHeight * bandFrac;
        const scale = Math.min(maxW / bandW, maxH / bandH);
        const dpr = Math.min(window.devicePixelRatio || 1, 2);

        const fullW = Math.round(bg.naturalWidth * scale * dpr);
        const fullH = Math.round(bg.naturalHeight * scale * dpr);
        const outW = fullW;
        const outH = Math.round(bandH * scale * dpr);

        this.zoomCanvas.width = outW;
        this.zoomCanvas.height = outH;
        this.zoomCanvas.style.width = Math.round(outW / dpr) + 'px';
        this.zoomCanvas.style.height = Math.round(outH / dpr) + 'px';

        const ctx = this.zoomCanvas.getContext('2d');
        ctx.save();
        ctx.translate(0, -Math.round(ZOOM_REGION.y0 * fullH));
        await this.drawScene(ctx, fullW, fullH, v, bg, flag);
        ctx.restore();
      } catch (err) {
        console.error('[Perso] Zoom-Fehler:', err);
      }
    }

    closeZoom() {
      if (this.zoomEl) this.zoomEl.hidden = true;
    }

    /* ---------- Finale PDF + Upload + Warenkorb ---------- */
    showError(msg) {
      this.errorEl.textContent = msg || '';
      this.errorEl.hidden = !msg;
    }

    setLoading(on, label) {
      this.submitBtn.disabled = on;
      this.submitBtn.classList.toggle('is-loading', on);
      const span = this.submitBtn.querySelector('span');
      if (span) {
        if (on) {
          if (!this.submitBtn.dataset.label) this.submitBtn.dataset.label = span.textContent;
          span.textContent = label || 'Wird erstellt…';
        } else if (this.submitBtn.dataset.label) {
          span.textContent = this.submitBtn.dataset.label;
        }
      }
    }

    async addToCart() {
      const v = this.values();
      this.showError('');
      if (!v.name) {
        this.showError('Bitte einen Namen eingeben.');
        return;
      }
      const variantId = this.currentVariantId();
      if (!variantId || !this.currentBgUrl()) {
        this.showError('Für die gewählte Variante ist keine Personalisierung verfügbar.');
        return;
      }

      this.setLoading(true, 'PDF wird erstellt…');
      try {
        // 1) Vollauflösung rendern
        const [bg, flag] = await Promise.all([this.getBg(), this.getFlag(v.land), this.ensureFonts()]);
        const W = bg.naturalWidth;
        const H = bg.naturalHeight;
        const canvas = document.createElement('canvas');
        canvas.width = W;
        canvas.height = H;
        await this.drawScene(canvas.getContext('2d'), W, H, v, bg, flag);

        // 2) JPEG → PDF
        const jpegBlob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.92));
        if (!jpegBlob) throw new Error('Bild konnte nicht erzeugt werden.');
        const jpegBytes = new Uint8Array(await jpegBlob.arrayBuffer());
        const pdfBlob = buildPdf(jpegBytes, W, H, PDF_DPI);

        // 3) Upload zu Supabase Storage
        this.setLoading(true, 'Wird hochgeladen…');
        const fileName = 'perso-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8) + '.pdf';
        const upRes = await fetch(this.cfg.supabaseUrl + '/storage/v1/object/' + this.cfg.bucket + '/' + fileName, {
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + this.cfg.supabaseKey,
            'apikey': this.cfg.supabaseKey,
            'Content-Type': 'application/pdf'
          },
          body: pdfBlob
        });
        if (!upRes.ok) {
          const t = await upRes.text().catch(() => '');
          throw new Error('Upload fehlgeschlagen (' + upRes.status + '). ' + t);
        }
        const pdfUrl = this.cfg.supabaseUrl + '/storage/v1/object/public/' + this.cfg.bucket + '/' + fileName;

        // 4) In den Warenkorb (Hauptprodukt + Aufschlag)
        this.setLoading(true, 'Wird hinzugefügt…');
        const qtyInput = document.querySelector('form[id^="product-form"] input[name="quantity"], input[id^="Quantity-"]');
        const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        const items = [{
          id: parseInt(variantId, 10),
          quantity: qty,
          properties: {
            'Name': v.name.toUpperCase(),
            '_Perso-PDF': pdfUrl
          }
        }];
        if (this.cfg.surchargeVariantId) {
          items.push({ id: this.cfg.surchargeVariantId, quantity: qty });
        }

        const cart = document.querySelector('cart-drawer');
        const sections = cart && cart.getSectionsToRender
          ? cart.getSectionsToRender().map((s) => s.id)
          : ['cart-drawer', 'cart-icon-bubble'];

        const addRes = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
        });
        const data = await addRes.json();
        if (!addRes.ok || data.status) {
          throw new Error(data.description || data.message || 'Konnte nicht in den Warenkorb gelegt werden.');
        }

        this.closeModal();
        if (cart && cart.renderContents && data.sections) {
          cart.renderContents(data);
        } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-personalization' });
        }
      } catch (err) {
        console.error('[Perso] Fehler:', err);
        this.showError(err.message || 'Etwas ist schiefgelaufen. Bitte erneut versuchen.');
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define('product-personalization', ProductPersonalization);
})();
